import React from "react";
import { Field, Form } from "formik";
import { Box } from "rebass";

import { fields, FormTypes } from "./formSettings";

import { Input } from "../components/Input";
import { SubmitButton } from "../components/SubmitButton";

export const FormComponent: React.FC<FormTypes> = ({ isSubmitting, isValid }) => (
  <Form>
    <Box>
      {
        fields.map(({ name, placeholder, type }) => (
          <Field
            key={name}
            name={name}
            type={type}
            placeholder={placeholder}
            component={Input}
          />
        ))
      }
    </Box>

    <Box
      mt="20px"
      fontSize="14px"
    >
      <SubmitButton disabled={isSubmitting || !isValid}>
        send
      </SubmitButton>
    </Box>
  </Form>
);
